/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextActionCheckIcon16Solid = forwardRef('TextActionCheckIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M3 7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "M3 11a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H3Z" }),
        React.createElement("path", { d: "m12.31 14.854 3.147-3.147a1 1 0 0 0-1.414-1.414l-2.793 2.793-1.293-1.293a1 1 0 0 0-1.414 1.414l1.646 1.647a1.5 1.5 0 0 0 2.122 0Z" })));
});
